
    <template>
        <div class="text-center mt-3">
          <span class="icon">
                   <font-awesome-icon icon="spinner" spin size="4x" color="#03a9f4e8"/>
          </span>
        </div>
    </template>

    <script>
        export default {
            name: "LoadingButton",
        }
    </script>

    <style scoped>
    </style>
